$(function () {
  var email = document.getElementById('career_email'),
    confirm_email = document.getElementById('career_email_confirmation');

  function validatePassword() {
    if (email.value != confirm_email.value) {
      confirm_email.setCustomValidity(
        I18n.t('career_offer_page.form.email_missmatch')
      );
    } else {
      confirm_email.setCustomValidity('');
    }
  }

  if (email) {
    email.onchange = validatePassword;
    confirm_email.onblur = validatePassword;
  }

  const disabilitySelectElement = document.getElementById('disability_select');
  const disabilityUploadField = document.getElementById(
    'disability_upload_field'
  );
  const disabilityUploadInput = document.getElementById(
    'formular_disability_upload'
  );
  const formSubmitBtn = document.querySelector('#career_submit_button');
  const allowedFormats = ['pdf', 'txt', 'jpg', 'jpeg', 'png', 'tif', 'tiff'];
  let formHasSubmitted = false;

  const setClassesOnInputs = (input) => {
    if (
      (input.tagName.toLowerCase() === 'input' && input.value.trim() === '') ||
      (input.tagName.toLowerCase() === 'select' && input.value === '')
    ) {
      input.classList.add('is-invalid');
    } else {
      input.classList.remove('is-invalid');
    }
  };

  const selectFormControlInputs = (action) => {
    const requiredFormControlInputs = document.querySelectorAll(
      '.form-control[required="required"]'
    );

    requiredFormControlInputs.forEach((input) => {
      if (action === 'submitted') {
        setClassesOnInputs(input);
      } else {
        input.addEventListener('change', () => {
          setClassesOnInputs(input);
        });
      }
    });
  };

  const selectCheckBoxInput = () => {
    const checkBox = document.querySelector('input[type="checkbox"]');
    const controlIndicator = checkBox?.nextElementSibling;

    if (checkBox && controlIndicator) {
      controlIndicator.classList.toggle('is-invalid', !checkBox.checked);
      checkBox.addEventListener('change', (e) => {
        controlIndicator.classList.toggle('is-invalid', !e.target.checked);
      });
    }
  };

  const checkFileValidity = (file, allowedFormats) => {
    const ext = file?.name.split('.').pop().toLowerCase();
    return allowedFormats.includes(ext);
  };

  const toggleInvalidClass = (customContainer, input) => {
    if (
      customContainer.style.display !== 'none' &&
      input.files.length === 0 &&
      formHasSubmitted
    ) {
      customContainer.classList.add('is-invalid');
    } else {
      customContainer.classList.remove('is-invalid');
    }
  };

  const toggleInvalidClassAndErrorMessage = (
    customContainer,
    errorMessageContainer,
    isValid
  ) => {
    if (!isValid) {
      errorMessageContainer.style.display = 'block';
      customContainer.classList.add('is-invalid');
    } else {
      errorMessageContainer.style.display = 'none';
      customContainer.classList.remove('is-invalid');
    }
  };

  const selectCustomFileInputs = () => {
    const requiredCustomFileInputs = document.querySelectorAll(
      '.custom-file-input[required]'
    );

    requiredCustomFileInputs.forEach((input) => {
      const customContainer = input.parentElement;
      const errorMessageContainer = customContainer.nextElementSibling;

      toggleInvalidClass(customContainer, input);

      input.addEventListener('change', ({ target }) => {
        if (!target.files.length) {
          customContainer.classList.add('is-invalid');
          errorMessageContainer.style.display = 'none';
          return;
        }

        const file = target.files[0];
        const isValid = checkFileValidity(file, allowedFormats);
        toggleInvalidClassAndErrorMessage(
          customContainer,
          errorMessageContainer,
          isValid
        );
      });
    });
  };

  disabilitySelectElement.addEventListener('change', (e) => {
    const shouldDisplay = e.target.selectedIndex === 1;
    disabilityUploadField.style.display = shouldDisplay ? 'block' : 'none';
    disabilityUploadInput[shouldDisplay ? 'setAttribute' : 'removeAttribute'](
      'required',
      'required'
    );

    if (formHasSubmitted) {
      selectFormControlInputs('submitted');
      selectCustomFileInputs();
      selectCheckBoxInput();
    }
  });

  formSubmitBtn.addEventListener('click', (e) => {
    formHasSubmitted = true;
    selectFormControlInputs('submitted');
    selectCustomFileInputs();
    selectCheckBoxInput();
  });

  selectFormControlInputs();
  selectCustomFileInputs();
});
